$('#nwsemail').keypress(function(event) {
    if (event.keyCode == 13) {
        event.preventDefault();
    }
});

function submitNewsletterForm(){
   // $("#newslettersubmitbtn").bind("click", function() {
        var reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var email = $('#nwsemail').val();
        if (email.trim() == '') {
            $("#nformmessage").html('<span>Lütfen boşluk bırakmayın.</span>');
            $(".newsletter-search-input").addClass('form-warning');
            return false;

        } else if (email.trim() != '' && !reg.test(email)) {
            $("#nformmessage").html('<span>Hatalı e-posta adresi girdin, lütfen tekrar dene!</span>');
            $(".newsletter-search-input").addClass('form-warning');
              return false;

        }
        else {
            $("#nformmessage").hide;
            alert("Valid email address.");

            //sent to ajax newsletter
            $.ajax({
                type: "POST",
                url: "/includes/ajaxtest.php",
                data: $('form.nwsletter').serialize(),
                success: function (message) {   //returm success message #newsletterdev you must delete this line production version
                    $(".newsletterdev").html(message);

                },
                error: function () {
                    alert("Error");
                }
            });
            $(".newsletter-search-input").removeClass('form-warning');
            $("#nformmessage").html('');
            $('#newsletterModal').modal('show'); //Open the model
            $('#newsletterform :input').val('');
        }

    }

function submitSuccessForm(){
    // $("#newslettersubmitbtn").bind("click", function() {
    var reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
    var pass = $('#newsletterPassword').val();


    if (pass.trim() == '') {
        $(".form-error-message").html('Lütfen boşluk bırakma!');
        $("#newsletterPassword").addClass('form-warning');
        return false;
    }  else if (pass.length < 6) {
        $(".form-error-message").html('Şifren en az 6 karakterden oluşmalı!');
        $("#newsletterPassword").addClass('form-warning');
        return false;
    }

    else {
        $(".form-error-message").html('');
        $("#newsletterPassword").removeClass('form-warning');
        alert("Data has been ready Ajax"); //Ajax buraya gelebilir.
        $('#newsletterModal').modal('hide'); //Open the model
        $('#newsletterreg :input').val('');
        //$("#newsletterreg")[0].reset(); // reset form
    }

}
